export default __webpack_public_path__ + "static/media/1951.c57208cf.png";